module.exports = __webpack_public_path__ + "img/rails.2db29782.svg";